import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

const cancelledStatuses = new Set(['cancel', 'cancelled', 'canceled', 'fail', 'failed', 'error']);

const AppPaymentReturn = () => {
    const { status } = useParams();
    const history = useHistory();
    const cancelled = cancelledStatuses.has((status || '').toLowerCase());

    useEffect(() => {
        const deepLink = cancelled ? 'clubapp://payment/cancel' : 'clubapp://payment/success';
        const fallback = cancelled ? '/catalog' : '/purchases';
        window.location.replace(deepLink);
        const timer = window.setTimeout(() => history.replace(fallback), 1200);
        return () => window.clearTimeout(timer);
    }, [cancelled, history]);

    return (
        <div style={{ padding: 48, textAlign: 'center' }}>
            {cancelled
                ? 'Оплата не завершена. Возвращаем в каталог…'
                : 'Оплата прошла. Открываем приложение…'}
        </div>
    );
};

export default AppPaymentReturn;
